import { Directive } from '@angular/core';

@Directive({
  selector: '[payee-progress-bar-next]',
})
export class PayeeProgressBarNextDirective { }
